import React, { Suspense } from 'react';
import cx from 'clsx';
import { useRouter } from 'next/router';
import { Button, Overlay, useOutsideClick } from '@kcd/design-system';

import useNonLoginPopupStore from '~/store/global/useNonLoginPopupStore';
import { changedByFontScale } from '~/utils/fontScale';
import { getAuthUrl } from '~/utils/mobileApp';

import Image from '../Image';

const PopupContents = () => {
  const popupRef = React.useRef<HTMLDivElement>(null);
  const router = useRouter();
  const { opened, closePopup, showCloseButton } = useNonLoginPopupStore();

  useOutsideClick({
    ref: popupRef,
    onClick: () => {
      if (opened) {
        closePopup();
      }
    },
  });

  const handleClickLogin = () => {
    void router.push(getAuthUrl());
  };

  if (!opened) {
    return null;
  }

  return (
    <Overlay inverted className="!z-[25] [&>div]:z-[25]">
      <div
        role="dialog"
        className={cx(
          'fixed top-0 left-0 right-0 bottom-0 h-full flex flex-col items-center justify-center',
          changedByFontScale() && 'scale-90',
        )}
      >
        <div
          className="flex max-h-[80%] w-4/5 max-w-[400px] flex-col items-center justify-evenly rounded-3xl bg-gray-000 p-20"
          ref={popupRef}
        >
          <div className="font-bold mb-12 mt-8 text-center typo-heading300">
            사업의 모든 순간,
            <br />
            캐시노트가 도와드릴게요
          </div>
          <Image
            src="https://asset.kcdcdn.net/images/new-start-1JbUQ5WRJkwqvTYJBWv95s.png"
            width={360}
            height={318}
            alt=""
          />
          <div className="w-full">
            <Button
              variant="primary"
              block
              type="button"
              onClick={handleClickLogin}
            >
              로그인하기
            </Button>
            {showCloseButton && (
              <Button
                variant="outline"
                className="!mt-12 w-full"
                onClick={closePopup}
              >
                캐시노트 마켓 상품 더 구경하기
              </Button>
            )}
          </div>
        </div>
      </div>
    </Overlay>
  );
};

export default function MarketNonLoginPopup() {
  return (
    <Suspense fallback={null}>
      <PopupContents />
    </Suspense>
  );
}
